(function(args) { 

	document.getElementById(args.id).innerHTML = `
		<div class="form-field search-filter publications-search-filter submit">					
	    	<a class="button-cta alt">Search</a>
	    </div>
	`;

	document.addEventListener('DOMContentLoaded', function() {
		document.addEventListener('click', function(e) {
			if (e.target.matches('.publications-search-filter.submit a')) {
				e.preventDefault(); 

				var form = jQuery('#form_publications');

				form[0].action = form[0].action.split('#')[0];
		        form[0].action += '#search-publications';
		    	form[0].submit();
			} 
		});
	});

})(args);